export default __webpack_public_path__ + "ad19ea010400fe2438ade8d6123c8359.svg";